import styled from "styled-components";

const StyledContact = styled.div`
  .tel {
    font-weight: 200;
  }
`;

export default StyledContact;
